module.exports = __webpack_public_path__ + "img/82.64262cf5.png";